var isValidHex = function isValidHex(hex) {
  return /^[\da-f]{6}$/i.test(hex);
};
var formatConfigColors = function formatConfigColors(rawColor) {
  var FALLBACK = "#eee";
  if (!rawColor) {
    return FALLBACK;
  }
  var colors = rawColor.trim().split("-");
  return colors.every(isValidHex) ? "#" + colors.join(", #") : FALLBACK;
};

export { formatConfigColors, isValidHex };
//# sourceMappingURL=colors.js.map
